/* eslint-disable */
import * as React from 'react';
import { FunctionComponent } from 'react';

//Material UI Core Elements
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material';

//Material UI Icons
import PublicIcon from '@mui/icons-material/Public';

//Custom Components
import StatusRoot from './StatusRoot';
import { getOptimalTextColorForBackgroundColor } from '@/lib/colorUtilities';

//Types
import { IStatusControl } from '@/@types/components/Map/Controls/Status';
import TenantContext, { TenantContextType } from '@/context/TenantContext/TenantContext';
import { ITenantProjectionSettings } from '@/@types/common';

const StatusControl: FunctionComponent<IStatusControl> = (props) => {
  const { changeCoordinateSystem } = props;

  const fontSize = 14;

  const theme = useTheme();

  const tenantContext = React.useContext(TenantContext) as TenantContextType;

  const [initialized, setInitialized] = React.useState(false);

  const { projectionSettings } = tenantContext;

  const genIcon = (setting: ITenantProjectionSettings) => {
    const defaultStyles = {
      size: 'small',
      fontSize: fontSize,
      borderRadius: '50%',
      margin: '0px 5px 0px 2px',
      cursor: 'pointer',
    };
    return (
      <Tooltip title={setting.name} placement="top" key={setting.epsg_code + '-coord-icon'}>
        <PublicIcon
          style={{
            color: theme.palette.primary.dark,
            backgroundColor: getOptimalTextColorForBackgroundColor(theme.palette.primary.main),
            ...defaultStyles,
          }}
          onClick={() => changeCoordinateSystem(setting.epsg_code)}
        />
      </Tooltip>
    );
  };

  React.useEffect(() => {
    if (!initialized && projectionSettings && projectionSettings.length > 0) {
      changeCoordinateSystem(projectionSettings[0].epsg_code);
      setInitialized(true);
    }
  }, [projectionSettings]);

  return (
    //@ts-ignore TODO: Property 'ref' is missing in type '{ children: Element; }' but required in type 'IStatusRoot', not sure where ref is taken from
    <StatusRoot>
      <Box
        m={0}
        style={{
          padding: '0px 5px',
          verticalAlign: 'baseline',
        }}
      >
        {projectionSettings && projectionSettings.length ? (
          projectionSettings.map((setting) => {
            return genIcon(setting);
          })
        ) : (
          <>
            {genIcon({ name: 'HTRS96/TM', epsg_code: 3765 })}
            {genIcon({ name: 'WGS84', epsg_code: 4326 })}
          </>
        )}
      </Box>
    </StatusRoot>
  );
};

export default StatusControl;
